import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { TranslateServerSideState } from '../types';

/**
 * 翻译任务服务端状态模型
 */
export interface TranslateServerSideModel extends Model<TranslateServerSideState>, Disposable {}

export const TranslateServerSideModel = Symbol('TranslateServerSideModel');
